// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hdqppk {
  display: flex;
  align-items: center;
}

.Jwi_6m {
  background-color: var(--surface-neutral-silver);
  transition: all 0.3s ease;
}

.Jwi_6m.X7kk9j {
  background-color: var(--surface-primary-medium);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/StepIndicator/StepIndicator.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[".stepIndicator {\n  display: flex;\n  align-items: center;\n}\n\n.stepIndicatorDot {\n  background-color: var(--surface-neutral-silver);\n  transition: all 0.3s ease;\n}\n\n.stepIndicatorDot.active {\n  background-color: var(--surface-primary-medium);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepIndicator": `Hdqppk`,
	"stepIndicatorDot": `Jwi_6m`,
	"active": `X7kk9j`
};
module.exports = ___CSS_LOADER_EXPORT___;
